import { useNavigate } from "react-router-dom";
import { Button } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/ui/button";
import { Activity, Heart, Moon, Footprints } from "lucide-react";

const FitbitConnect = () => {
  const navigate = useNavigate();

  const handleConnect = () => {
    // In production, this would initiate Fitbit OAuth flow
    // For now, just mark as connected and navigate to home
    localStorage.setItem("fitbitConnected", "true");
    navigate("/home");
  };

  const handleSkip = () => {
    localStorage.setItem("fitbitConnected", "false");
    navigate("/home");
  };

  return (
    <div className="bg-gradient-hero flex min-h-screen flex-col items-center justify-center p-6">
      <div className="w-full max-w-md space-y-8">
        {/* Logo */}
        <div className="flex flex-col items-center gap-4">
          <div className="bg-gradient-primary flex h-20 w-20 items-center justify-center rounded-[2rem] shadow-primary">
            <Activity className="h-10 w-10 text-primary-foreground" />
          </div>
        </div>

        {/* Content */}
        <div className="space-y-6 text-center">
          <h1 className="text-3xl font-bold text-foreground">
            Connect Your Fitbit
          </h1>
          <p className="text-muted-foreground">
            We'll use it to track steps, heart rate, sleep, and exercise to give
            you better Bite Balance predictions.
          </p>

          {/* Benefits */}
          <div className="space-y-3 pt-4">
            {[
              { icon: Footprints, text: "Track daily steps & activity" },
              { icon: Heart, text: "Monitor heart rate & calories" },
              { icon: Moon, text: "Analyze sleep quality" },
              { icon: Activity, text: "Optimize workout performance" },
            ].map((benefit, i) => (
              <div
                key={i}
                className="flex items-center gap-3 rounded-2xl border border-border/50 bg-card/50 p-4 backdrop-blur-sm"
              >
                <div className="bg-gradient-primary/10 flex h-10 w-10 items-center justify-center rounded-xl">
                  <benefit.icon className="h-5 w-5 text-primary" />
                </div>
                <span className="font-medium text-foreground">
                  {benefit.text}
                </span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="space-y-3 pt-6">
            <Button
              onClick={handleConnect}
              className="bg-gradient-primary h-14 w-full rounded-2xl text-lg shadow-primary hover:opacity-90"
            >
              Yes, Connect Now
            </Button>
            <Button
              onClick={handleSkip}
              variant="ghost"
              className="h-14 w-full rounded-2xl text-lg"
            >
              Not Now
            </Button>
          </div>

          <p className="pt-4 text-xs text-muted-foreground">
            Your data is secure and never shared without permission
          </p>
        </div>
      </div>
    </div>
  );
};

export default FitbitConnect;
